import { useQuery } from 'react-query'
import { fetchTestCyclesResults } from 'api/tests'
import type { TestCyclesResultsRequestParams } from 'api/tests'

export const useFetchTestCyclesResults = (
  params: TestCyclesResultsRequestParams
) => {
  return useQuery(['fetchSiteById', params], fetchTestCyclesResults(params))
}
